import { zodResolver } from "@hookform/resolvers/zod";
import { CreateCourseOrderMinuteRequest } from "services/courseMinutesService/Model/CourseSpeechesTypes";
import { z } from "zod";

export const getCreateCourseMinuteSchema = (t: any) => {
  const schema = z.object({
    courseOrderId: z.number().min(1, t("Common:invalidValue")),
    courseMinutesNumber: z.string().min(1, t("Common:invalidValue")),
    date: z.date({
      message: t("Common:invalidValue"),
    }),
    description: z.string().min(1, t("Common:invalidValue")),
    files: z.array(z.string(), { message: t("Common:invalidValue") }),
    users: z.array(z.string()).min(1, t("Common:invalidValue")),
  }) as z.ZodType<CreateCourseOrderMinuteRequest>;

  return zodResolver(schema);
};
